// removed by extract-text-webpack-plugin
module.exports = {"container":"_14b0a-FSv1t_TtKVFtymBx","icon":"_3K8nSeyeQeQWECB1Tx0Njs","title":"_1dMbAFKvsUWRXqujh3vYJE","Email":"tc3-GAaE1VA14RAq9TsWx","Signer":"_21dhw5FsRuKOyUmRWea4tp"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Documents/Document/FaceSigners/styles.css
// module id = 2898
// module chunks = 0